import React from 'react';

const STATUS_LABELS = {
  active: 'Ativo',
  pending: 'Pendente',
  blocked: 'Bloqueado',
  inactive: 'Inativo',
  cancelled: 'Cancelado',
  paid: 'Pago',
  delivered: 'Entregue',
  processing: 'Processando',
  ok: 'OK',
  published: 'Publicado',
  scheduled: 'Agendado',
  warning: 'Atenção',
  injured: 'Lesionado',
  live: 'Ao vivo',
  finished: 'Finalizado',
  draft: 'Rascunho',
};

export function StatusBadge({ value }) {
  const normalized = (value || '').toLowerCase();
  return <span className={`status-badge status-${normalized}`}>{STATUS_LABELS[normalized] || value || '-'}</span>;
}
